import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAngleDown,
  faAngleUp,
  faArrowLeft,
  faArrowRight,
  faArrowUp,
  faArrowDown,
  faBars,
  faBan,
  faCircle,
  faClipboard,
  faClipboardCheck,
  faCheck,
  faCog,
  faEye,
  faEyeSlash,
  faFilter,
  faLink,
  faHome,
  faMapMarkerAlt,
  faMinus,
  faPen,
  faPenToSquare,
  faPhoneAlt,
  faPlus,
  faPlusCircle,
  faRedoAlt,
  faReply,
  faReplyAll,
  faSearch,
  faShare,
  faSort,
  faSortDown,
  faSortUp,
  faStar as faStarSolid,
  faSyncAlt,
  faThLarge,
  faThList,
  faTimes,
  faTrash,
  faUndoAlt,
  faUser,
  faSliders,
} from '@fortawesome/free-solid-svg-icons';

import { faStar as faStarRegular } from '@fortawesome/free-regular-svg-icons';

export * from './Icon';

library.add(
  faAngleDown,
  faAngleUp,
  faArrowLeft,
  faArrowRight,
  faArrowUp,
  faArrowDown,
  faBan,
  faBars,
  faCircle,
  faCheck,
  faClipboard,
  faClipboardCheck,
  faCog,
  faEye,
  faEyeSlash,
  faFilter,
  faHome,
  faLink,
  faMapMarkerAlt,
  faMinus,
  faPen,
  faPenToSquare,
  faPhoneAlt,
  faPlus,
  faPlusCircle,
  faRedoAlt,
  faReply,
  faReplyAll,
  faSearch,
  faShare,
  faSliders,
  faSort,
  faSortDown,
  faSortUp,
  faStarRegular,
  faStarSolid,
  faSyncAlt,
  faThLarge,
  faThList,
  faTimes,
  faTrash,
  faUndoAlt,
  faUser
);

export const ICONS = {
  angleDown: 'angle-down',
  angleUp: 'angle-up',
  arrowLeft: 'arrow-left',
  arrowRight: 'arrow-right',
  arrowUp: 'arrow-up',
  arrowDown: 'arrow-down',
  ban: 'ban',
  bars: 'bars',
  circle: 'circle',
  clipboard: 'clipboard',
  clipboardCheck: 'clipboard-check',
  check: 'check',
  cog: 'cog',
  eye: 'eye',
  eyeSlash: 'eye-slash',
  filter: 'filter',
  home: 'home',
  link: 'link',
  mapMarkerAlt: 'map-marker-alt',
  farMapMarkerAlt: ['far', 'map-marker-alt'],
  minus: 'minus',
  pen: 'pen',
  penToSquare: 'pen-to-square',
  phoneAlt: 'phone-alt',
  plus: 'plus',
  plusCircle: 'plus-circle',
  redoAlt: 'redo-alt',
  reply: 'reply',
  replyAll: 'reply-all',
  search: 'search',
  share: 'share',
  sliders: 'sliders',
  sort: 'sort',
  sortDown: 'sort-down',
  sortUp: 'sort-up',
  starRegular: ['far', 'star'],
  starSolid: 'star',
  syncAlt: 'sync-alt',
  thLarge: 'th-large',
  thList: 'th-list',
  times: 'times',
  trash: 'trash',
  undoAlt: 'undo-alt',
  user: 'user',
};
